import React from 'react';
import { Helmet } from 'react-helmet';
import Overview from '../common/ShippingCostOverview';
import Text from '../common/Text';

const margin = '0.81em 0 0.5em';

const ShippingHelp = () => (
    <article about='/faq/recoloring' typeof='schema:WebPage'>
        <Text>
            <Text.Heading level={2} margin={margin}>Wie lange braucht Ihr?</Text.Heading>
            <p>Wir fertigen jeden Stoff individuell nach Bestelleingang.
                Es dauert deshalb ungefähr 3 Wochen bis wir
                Deinen individuellen
                Schnoff gedruckt, gewaschen, gebügelt und veredelt haben.
            </p>
            <Text.Divider />
            <Text.Heading level={2} margin={margin}>Was kostet der Versand?</Text.Heading>
            <Overview showEuImage />
            <Text.Divider />
            <Text.Heading level={2} margin={margin}>Mit wem versendet Ihr?</Text.Heading>
            <p>Unser aktueller Versandpartner ist Hermes. Griffmuster versenden wir mit
                der Post. Wir planen aber, dass Ihr euch künftig das Logistikunternehmen selbst wählen
                könnt. Das ist allerdings etwas aufwändig und braucht noch Zeit.
            </p>
        </Text>
    </article>
);

export default ShippingHelp;



// WEBPACK FOOTER //
// ./src/components/de/faq-shipping.js